import { ChangeDetectionStrategy, Component, ElementRef, HostBinding, input, inject } from '@angular/core';

type Appearance = 'default' | 'primary' | 'secondary' | 'darkgray' | 'google' | 'facebook' | 'danger';

type Size = 'normal' | 'md';

@Component({
    selector: 'button[emsysButton], a[emsysButton]',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ButtonComponent {
  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);


  @HostBinding('class.disabled')
  get disabledClass() {
    return this.disabled();
  }

  readonly disabled = input<boolean>(false);

  @HostBinding('class.loading')
  get loadingClass() {
    return this.showLoader();
  }

  readonly showLoader = input<boolean | null>(false);

  @HostBinding('attr.data-appearance')
  get appearanceAttr() {
    return this.appearance();
  }

  readonly appearance = input<Appearance>('default')

  @HostBinding('attr.data-size')
  get dataSizeAttr() {
    return this.size();
  }

  readonly size = input<Size>('normal');

  readonly icon = input<string>('');

  @HostBinding('attr.disabled')
  get nativeDisabled(): '' | null {
    return this.disabled() || this.showLoader() ? '' : null;
  }

}
